export default __webpack_public_path__ + "static/media/IMG_2833.7a207f48.jpeg";